import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetVendorTrialBalanceReportProps {
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorTrialBalanceReport = async (filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/vendor?${new URLSearchParams(filter).toString()}`);

const useGetVendorTrialBalanceReport = ({
  filter,
  queryParams,
}: UseGetVendorTrialBalanceReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor-trial-balance-report"],
    queryFn: () => getVendorTrialBalanceReport(filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetVendorTrialBalanceReport;
